import { ProductsRepository } from 'common/repositories/products';
import { BaseController } from './core/base';
import { ProductData } from 'common/types/models/product';
import { DeepReadonly } from '@zajno/common/types';
import { makeObservable, observable, runInAction } from 'mobx';
import { createLogger } from 'common/logger';
import { EdgeFunctions } from 'common/types/api';

const logger = createLogger('[ProductsController]');

export class ProductsController extends BaseController {
    private _repository: ProductsRepository = null;

    private _availableProducts: ProductData[] = null;

    constructor() {
        super();

        makeObservable<ProductsController, '_availableProducts'>(this, {
            _availableProducts: observable.ref,
        });
    }

    public get availableProducts(): ReadonlyArray<DeepReadonly<ProductData>> { return this._availableProducts; }

    public get repository() { return this._repository; }

    protected async onInitialize() {
        this._repository = new ProductsRepository(this.supabase)
            .useCaching(true);

        await this._loadProducts();
    }

    private _loadProducts = async () => {
        const result = await this._repository.getProducts();

        logger.log('Loaded available products:', result.map(p => `<${p.slug}>: ${p.name}`));

        runInAction(() => {
            this._availableProducts = result;
        });
    };

    public getSpotifyLink(url: string) {
        return this.runAction(async () => {
            const args: EdgeFunctions.Input<EdgeFunctions.Types.Links> = {
                type: 'spotify',
                link: url,
            };

            const result = await this.invokeFunction(EdgeFunctions.Types.Links, args);
            logger.log('checkout result =', result);

            return result.data;
        }, 'getlink');
    }
}

/* Example on how to load products standalone

 * import { ProductsController } from 'app/controllers/products';
 * import { setAuthPersistence } from 'app/services/supabase';
 *
 * // optionally set this to false to disable auth persistence in build time (otherwise will issue a warning localStorage is not available)
 * setAuthPersistence(false);
 *
 * // initialize the controller, can be done in any place
 * const productsController = await new ProductsController().initialize();
 *
 * // use the products
 * const products = productsController.availableProducts;
*/
